module.exports = __webpack_public_path__ + "static/media/flag-germany.5ad80ac7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/shared/LanguageFlag/LanguageFlagIcons/flag-germany.svg
// module id = 1128
// module chunks = 1